import { render, staticRenderFns } from "./SCounter.vue?vue&type=template&id=5546e424&scoped=true&"
import script from "./SCounter.vue?vue&type=script&lang=ts&"
export * from "./SCounter.vue?vue&type=script&lang=ts&"
import style0 from "./SCounter.vue?vue&type=style&index=0&id=5546e424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546e424",
  null
  
)

export default component.exports